<template>
  <div class="more-video-list academy-container">
    <header class="more-video-list-hd">
      <div
        class="academy-hd-wrapper"
        v-scroll-animate="{
          animation: 'fadeInDown',
        }"
      >
        <h4 class="academy-hd-subTitle">狄诺尼学院</h4>
        <h2 class="academy-hd-title">快速掌握{{ productType }}，从这里开始</h2>
        <h4 class="academy-hd-subTitle">
          {{ productType }}教学视频，帮助你快速学习
        </h4>
        <h4 class="academy-hd-subTitle">技术支持：4000-025-828</h4>
      </div>
    </header>
    <div class="topTitle">
      <div class="flex-row">
        <div style="width: 80px">当前位置：</div>
        <div class="backBtn" @click="back">狄诺尼学院&nbsp;> &nbsp;</div>
        <div class="videoTitle" :title="productType">
          {{ productType }}教学视频
        </div>
      </div>
    </div>

    <div class="content">
      <template v-if="dataList.length > 0">
        <div class="videoCard" v-for="item in dataList" :key="item.id">
          <img
            class="video-cover"
            :src="item.cover"
            alt=""
            @click="playVideo(item)"
          />
          <el-tooltip :content="item.title" placement="top-start">
            <h4 class="video-title" @click="playVideo(item)">
              {{ item.title }}
            </h4>
          </el-tooltip>
          <!-- <div class="academy-play flex" @click="playVideo(item)">
          <img src="@/assets/images/icon-play.svg" alt="" srcset="" />
          <div class="academy-text">查看教学视频</div>
        </div> -->
        </div>
      </template>
      <template v-else>
        <EmptyPage />
      </template>
    </div>
    <VideoModal :dialogVisible.sync="dialogVisible" :video="video"></VideoModal>
    <div
      style="margin: 0 auto; padding-bottom: 80px; width: fit-content"
      v-if="total > 0"
    >
      <Pagination
        layout="prev, pager, next"
        :isPadding="true"
        :page.sync="queryInfo.pageNum"
        :limit.sync="queryInfo.pageSize"
        :total="total"
        @pagination="handleSizeChange"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import {
  aiRoadVideoList,
  eiCadVideoList,
  vrRoadVideoList,
  report3DVideoList,
} from "./data.js";

import { collegevideoPageApi } from "@/api/website";
import Pagination from "@/components/Pagination.vue";
import EmptyPage from "@/components/EmptyPage.vue";
import VideoModal from "@/components/videoModal.vue";
import { tracklogApi } from "@/api/website";

export default {
  name: "moreVideoList",
  props: {},
  components: {
    EmptyPage,
    Pagination,
    VideoModal,
  },
  data() {
    return {
      productType: "AIRoad",
      categoryId: "",
      total: 0,
      queryInfo: {
        pageSize: 20,
        pageNum: 1,
      },
      dataList: [],
      dialogVisible: false,
      video: undefined,
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.productType = this.$route.query.anchor;
    this.categoryId = this.$route.query.categoryId;
    this.dataList = [];
    this.getVideoPage();
  },
  methods: {
    back() {
      this.$uniFun.openInCurrentTab(`/academy?&anchor=${this.productType}`);
    },
    getVideoPage() {
      let params = {
        current: this.queryInfo.pageNum,
        size: this.queryInfo.pageSize,
        categoryId: this.categoryId,
      };
      collegevideoPageApi(params).then((res) => {
        if (res.code === 200 && res.success) {
          console.log("collegevideoPageApi", res);
          this.dataList = res.data.records.map((item) => {
            return {
              id: item.id,
              title: item.title,
              cover:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              desc: item.description,
              videoUrl: item.url,
            };
          });
          this.total = res.data.total;
          console.log("dataList", this.dataList);
        }
      });
    },
    handleSizeChange(e) {
      this.queryInfo.pageNum = e.pageIndex;
      this.getVideoPage();
    },
    playVideo(video) {
      tracklogApi({ module: "4_" + video.id });
      let videoFormat = [".mp4", ".webm", "ogg", ".MP4"];
      // 判断地址是页面还是视频
      const url = new URL(video.videoUrl);
      const pathname = url.pathname;
      const isSupportedFormat = videoFormat.some((format) =>
        pathname.endsWith(format),
      );
      if (isSupportedFormat) {
        // 符合格式的视频，弹窗展示
        this.dialogVisible = true;
        this.video = video;
      } else {
        // 不符合的，跳转标签页
        window.open(video.videoUrl, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.more-video-list {
  background: white;
  padding-bottom: 38px;
  .more-video-list-hd {
    width: 100%;
    height: 320px;
    background: url("~@/assets/images/academy/academy-hd_bg.png") no-repeat
      center;
    background-size: cover;
    .academy-hd-wrapper {
      width: 1049px;
      padding-top: 70px;
      margin: 0 auto;
    }
    .academy-hd-title {
      margin-bottom: 20px;
      font-weight: bold;
      font-size: 28px;
      color: #ffffff;
      line-height: 28px;
      font-style: normal;
    }
    .academy-hd-subTitle {
      margin-bottom: 20px;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      line-height: 27px;
      font-style: normal;
    }
  }
  .topTitle {
    width: 100%;
    height: 64px;
    margin: 0 auto;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: left;
    border-bottom: 1px solid #d8d8d8;
    position: sticky;
    top: 80px;
    background: #fff;
    z-index: 20;
    > div {
      width: 1049px;
      margin: 0 auto;
      > div {
        height: 64px;
        line-height: 64px;
      }
      .videoTitle {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .backBtn {
    cursor: pointer;
    line-height: 64px;
  }
  .backBtn:hover {
    color: #0035fb;
    border-bottom: 2px solid #0035fb;
  }

  .content {
    width: 1049px;
    margin: 0 auto;
    padding: 40px 0;
    display: flex;
    flex-wrap: wrap; /* 允许换行 */
    gap: 44px; /* 卡片之间的间距 */
    // justify-content: space-between; /* 水平方向平均分布 */
    .videoCard {
      width: 320px;
      min-height: 284px;
      cursor: pointer;
      .video-title {
        cursor: pointer;
        min-height: 48px;
        margin-top: 12px;
        margin-bottom: 12px;
        font-weight: 600;
        font-size: 18px;
        color: #000000;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        @extend .text-truncate-multiline;
        --line-clamp: 2;
      }

      .video-cover {
        width: 100%;
        height: 200px;
        transition: all 0.3s;
        &:hover {
          transform: scale(1.05);
        }
      }
      .academy-play {
        cursor: pointer;
      }
      .academy-text {
        font-size: 14px;
        line-height: 16px;
        color: #333333;
        margin-left: 8px;
        &:hover {
          color: #0035fb;
        }
      }
    }
  }
}
</style>
